import React from 'react';

import Parallax from '../common/Parallax.jsx';

function InventoryImageParallaxComponent(props) {
    let inventory = props.data || {};
    if (inventory.inventory) {
        inventory = inventory.inventory;
    }
    let image;
    if (inventory.images && inventory.images.length > 0) {
        image = inventory.images[0];
    }
    return <Parallax.ImageContainer.Component {...props} data={[{ inventory,  image }]} slideComponent={InventoryImageParallaxCell} />
}

function InventoryImageParallaxCell(props) {
    let inventory = props.data || {};
    if (inventory.inventory) {
        inventory = inventory.inventory;
    }
    let image;
    if (inventory.images && inventory.images.length > 0) {
        image = inventory.images[0];
    }
    return <Parallax.ImageContainer.Cell {...props} image={image} />
}

export default { Cell: InventoryImageParallaxCell, Component: InventoryImageParallaxComponent };